import { getStaticJSON } from './_helpers';

export async function listStories(lang) {
  return await getStaticJSON(`/verhalen/${lang}.json`);
}
